
export const xpathPageIdx = (xpath: string): number|null => {
	if(!xpath) {
		return null
	}
	const parts = xpath.split('.')
	for(let part of parts) {
		if(part.startsWith('Page[')) {
			const idxStr = part.slice(5, -1)
			return Number(idxStr)
		}
	}
	return null
}

export const xpathIsHidden = (xpath: string): boolean => {
	if(!xpath) {
		return true
	}

	const parts = xpath.split('.')
	
	const hiddenNode = parts.find(nodeName => nodeName.startsWith('Hidden['))

	return !!hiddenNode
}

export const getVisibleXpathIfExists = (xpaths: string[]): string|null => {
	if(!xpaths || xpaths.length === 0) {
		return null
	}

	for(let xpath of xpaths) {
		if(xpathIsHidden(xpath) === false) return xpath
	}

	return null
}